/**
 * The key everything per-person on the client is stored under: nav
 * preferences, recents, saved views.
 *
 * User ids are bigints from the tenant's own schema (CLAUDE.md §4/§5), so
 * user 1 exists in every tenant. Keying on the id alone gave user 1 in tenant
 * X and user 1 in tenant Y one shared `erpx.web.1.nav.*` — and, because the
 * nav state is module-level and only re-read when the key changes, one shared
 * in-memory copy too. The tenant UUID makes the key unique across tenants.
 *
 * `'anon'` when nobody is signed in: nothing per-person is shown then, and a
 * stable value keeps the watchers keyed on this quiet.
 */

import { computed, type ComputedRef } from 'vue'

import { useAuthStore } from '@/stores/auth'

export function useUserScope(): ComputedRef<string> {
  const auth = useAuthStore()
  return computed(() => {
    const id = auth.user?.id
    if (id === undefined) return 'anon'
    return `${auth.tenantUuid}:${id}`
  })
}
